import React from 'react';
import { reportingCopy } from '../../../copy/advisor-dashboard/advisor-dashboard-base.json';

const currentYear = new Date().getFullYear();

const legendItems = {
  [currentYear]: reportingCopy.topChosen.hsColorScale[0],
  [currentYear + 1]: reportingCopy.topChosen.hsColorScale[1],
  [currentYear + 2]: reportingCopy.topChosen.hsColorScale[2],
  [currentYear + 3]: reportingCopy.topChosen.hsColorScale[3],
  [currentYear + 4]: reportingCopy.topChosen.hsColorScale[4],
};

export default function CurrentlyInHighSchoolLegend() {
  return (
    <div className="currently-in-high-school-legend">
      <div className="currently-in-high-school-legend__header">
        <div className="currently-in-high-school-legend__heading">
          Currently in High School
        </div>
      </div>
      <div className="currently-in-high-school-legend__container">
        {Object.entries(legendItems).map((item) => {
          return (
            <div
              className="currently-in-high-school-legend__item"
              key={`Class of ${item[0]}`}
            >
              <div
                className="currently-in-high-school-legend__color-square"
                style={{
                  backgroundColor: item[1],
                }}
              />
              <div className="currently-in-high-school-legend__label">
                {`Class of ${item[0]}`}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
